import createReactComponent from '../createReactComponent';
export default createReactComponent('mail-plus', 'IconMailPlus', [
  [
    'path',
    {
      d: 'M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M16 19h6', key: 'svg-1' }],
  ['path', { d: 'M19 16v6', key: 'svg-2' }],
  ['path', { d: 'M3 7l9 6l9 -6', key: 'svg-3' }],
]);
